import React, { useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const CreateEkinextModal = ({ onClose, onCreated }) => {
  const [formData, setFormData] = useState({
    product_name: '',
    product_type: 'software',
    email_sent_date: '',
    start_date: '',
    first_feedback_date: '',
    close_date: '',
    known_issues: '',
    available_units: '',
    status: 'pianificato'
  });

  const [loading, setLoading] = useState(false);

  function handleChange(field, value) {
    setFormData(prev => ({ ...prev, [field]: value }));
  }

    function formatDateIT(dateString) {
    if (!dateString) return '-';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
  }

async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);

  try {
    const dataToSend = { ...formData };
    
    if (dataToSend.product_type === 'software') {
      delete dataToSend.available_units;
    }

    console.log('📤 Payload inviato:', dataToSend);
    
    const res = await api.createEkinextProduct(dataToSend);
    
    console.log('📥 Risposta ricevuta:', res);
    
    if (res.success) {
      onCreated();
    } else {
      alert('Errore creazione: ' + (res.error || 'Errore sconosciuto'));
    }
  } catch (err) {
    console.error('❌ Eccezione completa:', err);
    console.error('❌ Messaggio errore:', err.message);
    console.error('❌ Stack trace:', err.stack);
    alert('Errore di connessione: ' + err.message);
  } finally {
    setLoading(false);
  }
}


  const quillModules = {
    toolbar: [
      ['bold', 'underline'],
      [{ 'list': 'bullet' }, { 'list': 'ordered' }]
    ]
  };

  return (
    <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Crea Nuovo Prodotto Ekinext</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Nome Prodotto *</label>
                <input
                  type="text"
                  className="form-control"
                  value={formData.product_name}
                  onChange={e => handleChange('product_name', e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Tipologia Prodotto *</label>
                <select
                  className="form-select"
                  value={formData.product_type}
                  onChange={e => handleChange('product_type', e.target.value)}
                  required
                >
                  <option value="software">Software</option>
                  <option value="hardware">Hardware</option>
                </select>
              </div>

              {formData.product_type === 'hardware' && (
                <div className="mb-3">
                  <label className="form-label">Pezzi a Disposizione</label>
                  <input
                    type="number"
                    className="form-control"
                    value={formData.available_units}
                    onChange={e => handleChange('available_units', e.target.value)}
                    min="0"
                  />
                </div>
              )}

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Data Invio Newsletter</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.email_sent_date}
                    onChange={e => handleChange('email_sent_date', e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Data Avvio Ekinext</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.start_date}
                    onChange={e => handleChange('start_date', e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Data Primo Feedback</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.first_feedback_date}
                    onChange={e => handleChange('first_feedback_date', e.target.value)}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Data Chiusura</label>
                  <input
                    type="date"
                    className="form-control"
                    value={formData.close_date}
                    onChange={e => handleChange('close_date', e.target.value)}
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label">Known Issues</label>
                <ReactQuill
                  theme="snow"
                  value={formData.known_issues}
                  onChange={value => handleChange('known_issues', value)}
                  modules={quillModules}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Stato</label>
                <select
                  className="form-select"
                  value={formData.status}
                  onChange={e => handleChange('status', e.target.value)}
                >
                  <option value="pianificato">Pianificato</option>
                  <option value="in_corso">In Corso</option>
                  <option value="concluso">Concluso</option>
                  <option value="abortito">Abortito</option>
                </select>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Annulla
              </button>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? 'Creazione...' : 'Crea Prodotto'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateEkinextModal;
